<template>
  <v-dialog v-model="show" persistent :max-width="width">
    <v-card class="pa-2">
      <v-card-title class="headline">{{ textHeader }}</v-card-title>
      <v-card-text>{{ textBody }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="show = false">Cancel</v-btn>
        <v-btn color="red darken-1" class="white--text" @click="onConfirm">Confirm</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {

  props: {
    value: {
      type: Boolean,
      default: false
    },
    width: {
      type: [String, Number],
      default: 290
    },
    textHeader: {
      type: String,
      default: 'Are you sure you want to delete this record?'
    },
    textBody: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      show: this.value
    }
  },

  methods: {
    onConfirm () {
      this.$emit('deleteDetails')
      this.show = false
    }
  },

  watch: {
    show (val) {
      this.$emit('input', val)
    },
    value (val) {
      this.show = val
    }
  }
}
</script>

<style scoped>
.headline {
  word-break: initial;
}
</style>
